<template>
    <div class="">
        <!-- imported coponents -->
        <importFromCSV :units="units"
            v-on:alert="showAlert"
            v-on:success="showSuccess"/>
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="cubes"></vue-fontawesome>
            Products
        </h1>            
        <div>
            <div class="d-flex justify-content-between">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Products
                            </a>
                        </li>                       							
                </ul>                
            </div>	            							
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab">
                    <div class="mb-5 d-flex justify-content-between">
                        <!-- right -->
                        <section class="d-flex">                           
                            <div class="dropdown">
                                <a class="btn btn-outline-success dropdown-toggle" 
                                    href="#" role="button" id="dropdownMenuLink" 
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>filter
                                </a>
                                <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                        <div class="form-group d-flex justify-content-between">
                                            <label class="p-2">Search</label>
                                            <input type="text" class="col-8 form-control" v-model="search"> 
                                        </div>                                                                               	
                                </div>
                            </div>
                            <div class="ml-2">
                                <button class="btn btn-outline-success"
                                    @click="$exportTable('productsTable','products.csv')">
                                    <vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>
                                    Export
                                </button>	
                            </div>	
                            <div class="ml-2">
                                <div class="form-group d-flex justify-content-between">
                                    <label class="p-2"> <vue-fontawesome class="mr-2" icon="search"></vue-fontawesome></label>
                                    <input type="text" placeholder="search" class="form-control" v-model="search"> 
                                </div> 
                            </div>
                        </section>  
                        <!-- add buttons -->
                        <section>                            
                            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
								<button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addProductModal" >
									Add product
								</button>                               
                                <button id="btnGroupDrop1" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">                                    
                                </button>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                    <a class="cursor-pointer dropdown-item"  data-toggle="modal" data-target="#importFromCSV"
                                        @click="getUnits()">
                                        Import from CSV
                                    </a>                                 
                                </div>
                            </div>
                        </section>				
                    </div>    
                    <!-- PRODUCTS TABLE AND DEPENDENCIES -->
                    <div class="rounded shadow border border-light p-2">                       
                        <!-- top pagination for paginated product data-->
                        <div class="d-flex justify-content-between rounded bg-light">
                            <div class="d-flex ml-3 mt-3">
                                <label class="anvil-checkbox">
                                    <input multiple type="checkbox"  v-model="all_selected">
                                    <span class="anvil-checkmark"></span>
                                </label>
                                <div class="ml-5" v-if="products">{{product_ids.length}} / {{products.length}} selected</div>
                                <!-- selected products actions -->
                                <div class="ml-3 p-1 shadow rounded" v-if="product_ids.length">
                                     <!-- transfer -->
                                    <button class="btn btn-outline-success actions" data-toggle="modal" data-target="#transferStockModal"
                                        @click="getLocations()">
                                        <vue-fontawesome class="cursor-pointer" icon="exchange"></vue-fontawesome>
                                    </button>
                                    <!-- delete -->
                                    <button class="ml-2 btn btn-outline-danger actions" data-toggle="modal" data-target="#deleteProductsModal">
                                        <vue-fontawesome class="cursor-pointer text-danger" icon="trash-o"></vue-fontawesome>
                                    </button> 
                                </div>                                                             
                            </div>
                            <div class="d-flex justify-content-end" v-if="products.length > 100">
                                <button class="btn" @click="prevPage"
                                    :disabled="pageNumber == 0">
                                    <i class="arrow left"></i>
                                </button>
                                <span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
                                <button class="btn" @click="nextPage"
                                    :disabled="(pageNumber+1) == pageCount">
                                    <i class="arrow right"></i>
                                </button>
                            </div>
                        </div>                     
                        <table class="table table-borderless table-responsive-sm paginate" 
                            id="productsTable"
                            data-pagecount="3">
                            <thead class="">                                
                                <tr>		                            
                                    <th scope="col"> </th>
                                    <th scope="col"></th>
                                    <th scope="col " 
                                        @click="$sortTable(2,'productsTable')">
                                        <i class="arrow up"></i>
                                        Name
                                    </th>          
                                    <th scope="col" 
                                        v-if="$hasPermission('CREATE_PURCHASE')"
                                        @click="$sortTable(3,'productsTable')">
                                        <i class="arrow up"></i>
                                        Purchase price
                                    </th>                          
                                    <th scope="col" 
                                        @click="$sortTable(4,'productsTable')">
                                        <i class="arrow up"></i>
                                        Retail price
                                    </th>	
                                    <th scope="col" 
                                        @click="$sortTable(5,'productsTable')">
                                        <i class="arrow up"></i>
                                        Wholesale price
                                    </th>	
                                    <th scope="col" 
                                        @click="$sortTable(6,'productsTable')">
                                        <i class="arrow up"></i>
                                        Tax
                                    </th>	
                                    <th scope="col"  
                                        @click="$sortTable(7,'productsTable')">
                                        <i class="arrow up"></i>
                                        Min required
                                    </th>	
                                    <th scope="col" 
                                        @click="$sortTable(8,'productsTable')">
                                        <i class="arrow up"></i>
                                        Stock
                                    </th>	                                				
                                    <th scope="col"></th>	
                                </tr>
                            </thead>
                            <tbody v-if="products && products.length">
                                <!-- initially selected row -->                           
                                <tr class="rounded cursor-pointer" style="border-radius: 15px" v-for="(product,index) in paginatedData" :key="index"
                                    :class="{'border border-success font-italic text-secondary': product_ids.includes(product.id)}">
                                    <td>
                                        <label class="anvil-checkbox p-3">
                                            <input multiple type="checkbox" :value=product.id v-model="product_ids">
                                            <span class="anvil-checkmark"></span>
                                        </label>
                                    </td>
                                    <td>
                                        <span class="float-left rounded bg-light" style="height:50px;width:50px"
                                            @click="openEditImageModal(product.id)"> 
                                            <img v-if="product.img_urls.length" class="image-fit" 
                                                :src="product.img_urls[0]" alt="">                                  
                                        </span>
                                    </td>	
                                    <td>{{product.name}}</td>		                                                                 
                                    <td> 
                                        <span class="d-none">{{product.purchase_price}}</span>
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.purchase_price" type="number" @focus="showSaveBtn(`purchase_price_btn${product.id}`)">
                                            <button :id="`purchase_price_btn${product.id}`"                                            
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`purchase_price_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span>                                                                               
                                    </td>
                                    <td>                                    
                                        <span class="d-none">{{product.retail_price}}</span>    
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.retail_price" type="number" @focus="showSaveBtn(`retail_price_btn${product.id}`)">
                                            <button :id="`retail_price_btn${product.id}`" 
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`retail_price_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span> 
                                    </td>																
                                    <td>  
                                        <span class="d-none">{{product.wholesale_price}}</span>                               
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.wholesale_price" type="number" @focus="showSaveBtn(`wholesale_price_btn${product.id}`)">
                                            <button :id="`wholesale_price_btn${product.id}`" 
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`wholesale_price_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span> 
                                    </td>
                                    <td> 
                                        <span class="d-none">{{product.tax}}</span>                                       
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.tax" type="number" @focus="showSaveBtn(`tax_btn${product.id}`)">
                                            <button :id="`tax_btn${product.id}`" 
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`tax_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span> 
                                    </td>
                                    <td>    
                                        <span class="d-none">{{product.minimum_required}}</span>                                    
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.minimum_required" type="number" @focus="showSaveBtn(`min_required_btn${product.id}`)">
                                            <button :id="`min_required_btn${product.id}`" 
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`min_required_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span> 
                                    </td>
                                    <td>    
                                        <span class="d-none">{{product.stock}}</span>                                    
                                        <span class="d-flex flex-column">
                                            <input class="form-control border-0" v-model="product.stock" type="number" @focus="showSaveBtn(`in_stock_btn${product.id}`)">
                                            <button :id="`in_stock_btn${product.id}`" 
                                                class="mt-2 d-none btn btn-sm btn-outline-success"
                                                @click="selectProduct(product);editProduct();hideSaveBtn(`in_stock_btn${product.id}`)">
                                                Save
                                            </button>
                                        </span>
                                    </td>
                                    <div class="p-3">
                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Actions
                                        </a>
                                        <span class="dropdown-menu rounded shadow border-0" aria-labelledby="dropdownMenuLink">                                                                                        
                                            <router-link class="dropdown-item" 
                                                :to="{ path: `product-detail/${product.id}`, query: { product : product }}">
                                                <vue-fontawesome class="cursor-pointer" icon="tachometer"></vue-fontawesome><span class="ml-2">View dashboard</span>
                                            </router-link>                                            
                                            <button :id="`editModalButton${product.id}`" class="dropdown-item" data-toggle="modal" data-target="#editProductModal" 
                                                @click="selectProduct(product)">
                                                <vue-fontawesome class="cursor-pointer" icon="pencil"></vue-fontawesome><span class="ml-2">Edit</span>
                                            </button>                                            
                                            <button class="dropdown-item text-danger"
                                                @click="deleteProduct(product)">
                                                <vue-fontawesome class="cursor-pointer text-danger" icon="trash-o"></vue-fontawesome><span class="ml-2">Delete</span>
                                            </button>                                            									
                                        </span>
                                    </div>                              
                                </tr>											
                            </tbody>
                        </table>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="products && ! products.length">
                            No records to show
                        </div>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="! products">
                            <div class="spinner-border p-3 m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>  
                        <!-- bottom pagination -->
                        <div class="d-flex justify-content-end" v-if="products.length > 100">
                            <button class="btn" @click="prevPage"
                                :disabled="pageNumber == 0">
                                <i class="arrow left"></i>
                            </button>
                            <span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
                            <button class="btn" @click="nextPage"
                                :disabled="(pageNumber+1) == pageCount">
                                <i class="arrow right"></i>
                            </button>
                        </div>
                    </div>                    
                </div>                
            </div> 		  
        </div>	
        <!-- modals -->
        <section>
            <!-- add product modal -->
            <div class="modal fade" id="addProductModal" tabindex="-1" role="dialog" aria-labelledby="addProducModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-0">
                            <h5 class="modal-title">Add Product</h5>
                            <button type="button" id="closeAddProductModal" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>                                                    
                        <form id="addProductForm">
                                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="pills-detail-tab" data-toggle="pill" href="#pills-detail" role="tab" aria-controls="pills-detail" aria-selected="true">Details</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-images" role="tab" aria-controls="pills-images" aria-selected="false">Images</a>
                                    </li>                                   
                                </ul>
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" id="pills-detail" role="tabpanel" aria-labelledby="pills-detail-tab">
                                        <div class="modal-body"  style="max-height: 60vh; overflow-y: scroll">                                                                                            
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">Name</label>
                                                    <input type="text" class="col-8 form-control" v-model="product_to_be_added.name" required>
                                                </div>     
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">Description</label>                                        
                                                    <textarea rows="3" class="col-8 form-control" v-model="product_to_be_added.description"></textarea>
                                                </div>                  
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">SKU</label>
                                                    <input type="text" class="col-8 form-control" v-model="product_to_be_added.sku">
                                                </div> 
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">VAT</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.tax">
                                                </div> 
                                                <div class="p-3 d-flex justify-content-between flex-wrap">
                                                    <label class="font-weight-bold">Units</label>
                                                    <select class="col-8 form-control" v-model="product_to_be_added.uom_id" required>
                                                        <option v-for="(unit,index) in units" :key="index" :value="unit.id">
                                                            {{unit.unit}}
                                                        </option>
                                                    </select>                                        
                                                    <small class="d-flex justify-content-center col-8 text-danger" v-if="units && ! units.length">
                                                        <p>Your shop has no units of measure added
                                                            <br>
                                                            this is required for adding a product
                                                            <br>                                        
                                                        </p>
                                                        <br>                                                                                        
                                                    </small>
                                                </div>
                                                <div class="p-3 d-flex justify-content-between">                                                    
                                                    <label class="font-weight-bold">Purchase price</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.purchase_price" required>
                                                </div> 
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">Retail price</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.retail_price">
                                                </div> 
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">wholesale price</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.wholesale_price">
                                                </div> 
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">Minimum required</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.minimum_required" required>
                                                </div>                                      
                                                <div class="p-3 d-flex justify-content-between">
                                                    <label class="font-weight-bold">Initial stock</label>
                                                    <input type="number" class="col-8 form-control" v-model="product_to_be_added.stock">
                                                </div>                                                                                                                                                       
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="pills-images" role="tabpanel" aria-labelledby="pills-images-tab">
                                        <div class="modal-body"  style="min-height: 60vh; overflow-y: scroll">  
                                            <div class="p-3 d-flex justify-content-between">
                                                    <imageInput v-model="product_images"/>                                                       
                                            </div>                                                                                                                                                                                                                                                                                            
                                        </div>
                                    </div>                                    
                                </div>                                
                                <div class="modal-footer border-0">                            
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                    <button type="submit" class="btn btn-success"
                                        @click="addProduct()">                                                        
                                        Add product
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding_product"></span>
                                    </button>
                                </div>
                        </form>                                                                                                                         
                    </div>
                </div>
            </div>
            <!-- edit product modal -->
            <div class="modal fade" id="editProductModal" tabindex="-1" role="dialog" aria-labelledby="editProducModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document" v-if="product">
                        <div class="modal-content">
                            <div class="modal-header border-0">
                                <h5 class="modal-title">{{product.name}}</h5>
                                <button type="button" id="closeEditProductModal" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div> 
                            <form id="editProductForm">
                                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active"  data-toggle="pill" href="#pills-update-detail" role="tab" aria-controls="pills-update-detail" aria-selected="true">Details</a>
                                    </li>
                                    <li class="nav-item">
                                        <a id="imageTabButton" class="nav-link" data-toggle="pill" href="#pills-update-images" role="tab" aria-controls="pills-update-images" aria-selected="false">Images</a>
                                    </li>                                   
                                </ul>
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" id="pills-update-detail" role="tabpanel" aria-labelledby="pills-update-detail-tab">
                                        <div class="modal-body"  style="max-height: 60vh; overflow-y: scroll">                                                                                      
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Name</label>
                                                <input type="text" class="col-8 form-control" v-model="product.name" required>
                                            </div>     
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Description</label>                                        
                                                <textarea rows="3" class="col-8 form-control" v-model="product.description"></textarea>
                                            </div>                  
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">SKU</label>
                                                <input type="text" class="col-8 form-control" v-model="product.sku">
                                            </div> 
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">VAT</label>
                                                <input type="number" class="col-8 form-control" v-model="product.tax">
                                            </div> 
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Units</label>                                                                                        
                                                <select class="col-8 form-control" v-model="product.uom_id" required>
                                                    <option v-for="(unit,index) in units" :key="index" :value="unit.id">
                                                        {{unit.unit}}
                                                    </option>
                                                </select>                                           
                                            </div>
                                            <div class="p-3 d-flex justify-content-between"
                                                v-if="$hasPermission('SUPER_ADMIN')">                                                
                                                <label class="font-weight-bold">edit Purchase price</label>
                                                <input type="number" class="col-8 form-control" v-model="product.purchase_price" required>
                                            </div> 
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Retail price</label>
                                                <input type="number" class="col-8 form-control" v-model="product.retail_price">
                                            </div> 
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">wholesale price</label>
                                                <input type="number" class="col-8 form-control" v-model="product.wholesale_price">
                                            </div> 
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Minimum required</label>
                                                <input type="number" class="col-8 form-control" v-model="product.minimum_required" required>
                                            </div>                                      
                                            <div class="p-3 d-flex justify-content-between">
                                                <label class="font-weight-bold">Initial stock</label>
                                                <input type="number" class="col-8 form-control" v-model="product.stock">
                                            </div>                                                                                                                                                       
                                        </div>
                                        <div class="modal-footer border-0">                            
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button type="submit" class="btn btn-success"
                                                @click="editProduct()">                                                        
                                                Save changes
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding_product"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="pills-update-images" role="tabpanel" aria-labelledby="pills-update-images-tab">                                        
                                        <div class="modal-body"  style="min-height: 60vh; overflow-y: scroll">                                              
                                            <div class="p-3 d-flex justify-content-between">                                                
                                                <div v-for="(url,index) in product.img_urls" :key="index" @click="unselectImage(index,url)"
                                                    :id="`current_image_${index}_card`"
                                                    class="ml-3 mr-5 image-draft card shadow d-flex flex-column justify-content-center" 
                                                    style="min-width:15rem ">                                      
                                                    <img :src="url" alt="" class="card-img" style="max-height: 100%; object-fit: contain">
                                                </div>    

                                                <imageInput v-model="product_images"/>                                                       
                                            </div>                                                                                                                                                                                                                                                                                              
                                        </div>
                                        <div class="modal-footer border-0">                            
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <button type="submit" class="btn btn-success"
                                                @click="addProductImages()">                                                        
                                                Save image changes
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding_product"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>                                                               
                            </form>                                                                                                                                                                                                                                     
                        </div>
                    </div>
            </div>
            <!-- delete products modal -->
            <div class="modal fade" id="deleteProductsModal" tabindex="-1" role="dialog" aria-labelledby="editProducModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header border-0">
                                <h5 class="modal-title">delete products</h5>
                                <button type="button" id="closeEditProductModal" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div> 
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-update-detail" role="tabpanel" aria-labelledby="pills-update-detail-tab">
                                    <div class="modal-body"  style="max-height: 60vh; overflow-y: scroll" v-if="product_ids.length < 100">                                                                                                                                                      
                                        <h3>delete {{product_ids.length}} products</h3>  
                                        <small v-if="deleting_products && product_ids.length > 50" class="text-danger">This may take a while</small>                                                                                                                                          
                                    </div>
                                    <div class="modal-body"  style="max-height: 60vh; overflow-y: scroll" v-else>                                                                                                                                                      
                                        <h3>delete {{product_ids.length}} products</h3>  
                                        <small class="text-danger">Too many products selected, select 100 at a time</small>                                                                                                                                          
                                    </div>
                                    <div class="modal-footer border-0">                            
                                        <button type="button" id="closeDeleteProductsModal" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success" v-if="product_ids.length < 100"
                                            @click="deleteMultipleProducts()">                                                        
                                            delete products
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="deleting_products"></span>
                                        </button>
                                    </div>
                                </div>                               
                            </div>                                                                                                                                                                                                                                            
                        </div>
                    </div>
            </div>
            <!-- transfer stock modal -->
            <div class="modal fade" id="transferStockModal" tabindex="-1" role="dialog" aria-labelledby="transferStockModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title" id="exampleModalCenterTitle">                            
                            Transfer stock for products<br/>
                        </h5>
                        <button type="button" id="closeTransferStockModal" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="transferStockForm">
                        <div class="modal-body">                    
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Transfer Date</label>
                                    <input type="date" class="col-8 form-control" v-model="stock_transfer.date" required>
                                </div>     
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">From</label>
                                    <select class="col-8 form-control" v-model="current_location_id" disabled>                                        
                                        <option v-for="(location,index) in current_location" :key="index" :value="location.id">
                                            {{location.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">To</label>
                                    <select class="col-8 form-control" v-model="stock_transfer.to_location" required>
                                        <option v-for="(location,index) in other_locations" :key="index" :value="location.id">
                                            {{location.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Units</label>
                                    <input type="number" class="col-8 form-control" v-model="stock_transfer.quantity" required>
                                </div>  
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Reason</label>
                                    <textarea rows="3" class="col-8 form-control" placeholder="Reason for transferring stock" v-model="stock_transfer.reason"></textarea>                                    
                                </div>                                                                                                                                           
                        </div>
                        <div class="modal-footer border-0">                            
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success"
                                @click="transferStock()">                                                        
                                Transfer stock
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="transfering_stock"></span>
                            </button>
                        </div>
                    </form>                
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import importFromCSV from './components/importFromCSV'
import imageInput from '@/components/imageInput'
export default {
    name: 'products',
    components:{importFromCSV,imageInput},
    props: {
        msg: String
    },
    data(){
        return{
            //paginate products list
            pageNumber: 0,  // default to page 1
            size:100,
            //search
			search:'',
            products:null,
            //select products
            product_ids: [],
            all_product_ids:[],
            all_selected: false,
            deleting_products: false,
            percent_completed:0,
            //locations
            locations:null,
            current_location:null,
            other_locations:null,
            transfering_stock:false,
            //selected location
            location: null,
            stock_transfer:{
                date : this.$moment().format('YYYY-MM-DD') 
            },
            //selected product
            product:null,   
            units: null,     
            //receipt modal.
            receipt_modal_data:null,            
            adding_product:false,
			product_images: [],
			image_urls: [],
            product_to_be_added:{
                id: null,
                product_type: 'n/a',
                name: null,
                sku: 'n/a',
                description: 'n/a',
                purchase_price: null,
                retail_price: null,
                base_selling_price: null,                                        
                wholesale_price: null,
                minimum_required: null,
                tax: null,
                stock: null,                                        
            },                
        }
    },
    computed:{
        account_switched(){
            return this.$store.state.account_switch_count
        },
        current_location_id(){
            return JSON.parse(localStorage.getItem('logged_in_user_location_id'))
        },
        pageCount(){		
            let l = this.products.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        paginatedData(){                        
            const start = this.pageNumber * this.size,
            end = start + this.size
            if (! this.search.length){                                
                return this.products.slice(start, end)
            }            
            else{                                            
                var filtered_list = this.products.filter((p)=>{
                    return p.name.toUpperCase().includes(this.search.toUpperCase())
                })                             
                return filtered_list.slice(start, end);
            }
        }
    },
    watch:{
        account_switched: function(){
            this.getProducts()
            this.getUnits()
        },
        search: function(){
            if (this.search){
                this.pageNumber = 0
            }            
        },        
        all_selected: function(){
            if (this.all_selected){
                this.product_ids = this.all_product_ids
            }
            else{
                this.product_ids = []
            }
        }
    },
    mounted(){            
        this.getProducts()
        this.getUnits()
    },    
    methods:{
        nextPage(){
            this.pageNumber++
        },
        prevPage(){
            this.pageNumber--
        },
        showAlert: function(message){
            this.$emit('alert',message)
        },
        showSuccess: function(message){
            this.$emit('success',message) 
            this.getProducts()
        },
        showSaveBtn(btn_id){ 
            console.log(btn_id)           
            var btn = document.getElementById(btn_id)            
            btn.classList.remove('d-none')
        },
        hideSaveBtn(btn_id){            
            var btn = document.getElementById(btn_id)            
            btn.classList.add('d-none')
        },
        //open edit image modal.
        openEditImageModal: function(product_id){
            document.getElementById(`editModalButton${product_id}`).click()
            setTimeout(()=>{
                document.getElementById('imageTabButton').click()
            },500)            
        },
        //get products	
        getProducts: function(){		
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/products/`,
                headers:{			
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.all_product_ids = []
                this.products = response.data
                for (var product of this.products){
                    this.all_product_ids.push(product.id)                
                }
            }).catch((err)=>{
                this.$emit('alert',err)
            })
        },	   
        selectProduct: function(product){
            this.product = product
            this.product_images = []
            this.image_urls = product.img_urls
        },
        //locations types for when ransfering
        getLocations: function(){                            
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },                
            }).then((response)=>{
                this.locations = response.data
                //locations other than current
                this.other_locations  = this.locations.filter((location)=>{ 
                    return location.id != this.current_location_id
                }) 
                // current location       
                this.current_location  = this.locations.filter((location)=>{ 
                    return location.id === this.current_location_id
                }) 
            }).catch((err)=>{
                alert(err)
            })
        },       
        //transfer stock
        transferStock: function(){
            var requests = []
            var is_valid = document.getElementById('transferStockForm').checkValidity()
            if(is_valid){
                this.transfering_stock = true
                for (var id of this.product_ids){
                    requests.push(
                        this.$http({
                            method:'post',				
                            url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/transfer/`,
                            headers:{
                                Authorization: JSON.parse(localStorage.getItem('auth_token'))
                            },                
                            data:{
                                transfer: {                            
                                    date: this.stock_transfer.date,
                                    reason: this.stock_transfer.reason || 'None given',
                                    quantity: this.stock_transfer.quantity,
                                    product: id,
                                },
                                from_id: this.current_location_id,
                                to_id: this.stock_transfer.to_location
                            }
                        })
                    )
                }  
                //make all requests
                this.axios.all(requests
                ).then(
                    this.axios.spread((...responses)=>{         
                        this.transfering_stock = false                         
                        document.getElementById('closeTransferStockModal').click()                    
                        this.$emit('success',`${responses.length} products transfered`)
                        this.product_ids = []
                    })
                )
                .catch((err)=>{
                    this.transfering_stock = false
                    this.$emit('alert',err)
                })
            }         
        },
        //get units of measurement for adding products       
        getUnits: function(){		
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/list-units/`,
                headers:{			
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.units = response.data                
            }).catch((err)=>{
                this.$emit('alert',err)
            })
        },	  
        //add product
        addProduct: function(){
            var is_valid = document.getElementById('addProductForm').checkValidity()
            if(is_valid){
                this.adding_product = true                
                this.$http({
                    method:'post',
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },  
                    data:{
                        id: this.$randID(),
                        product_type: this.product_to_be_added.product_type || "n/a",
                        name: this.product_to_be_added.name,
                        sku: this.product_to_be_added.sku || "n/a",
                        description: this.product_to_be_added.description || "n/a",
                        purchase_price: this.product_to_be_added.purchase_price,
                        retail_price: this.product_to_be_added.retail_price || "n/a",
                        uom_id: this.product_to_be_added.uom_id,
                        base_selling_price: this.product_to_be_added.base_selling_price || "n/a",
                        img_urls: [],
                        video_url: "n/a",
                        wholesale_price: this.product_to_be_added.wholesale_price || "n/a",
                        minimum_required: this.product_to_be_added.minimum_required,
                        tax: this.product_to_be_added.tax || "0",
                        stock: this.product_to_be_added.stock || 0,
                        other_costs: [],
                        variations: [],
                        variants: [],
                        discount: "0"
                        }
                }).then((response)=>{
                    this.adding_product = false
                    this.product_to_be_added = {
                        id: null,
                        product_type: 'n/a',
                        name: null,
                        sku: 'n/a',
                        description: 'n/a',
                        purchase_price: null,
                        retail_price: null,
                        base_selling_price: null,                                        
                        wholesale_price: null,
                        minimum_required: null,
                        tax: null,
                        stock: null,                                        
                    }                      
                    this.getProducts()                    
                    if(this.product_images.length){                        
                        this.addProductImages()
                    }
                    this.selectProduct(response.data)
                    document.getElementById('closeAddProductModal').click()                
                }).catch((err)=>{
                    this.adding_product = false
                    alert(err)                    
                })
            }
        },
        //edit product to include 
        editProduct: function(){                                   
            var is_valid = true //quick fix
            if(is_valid){
                this.adding_product = true
                this.product.img_urls = this.image_urls                        
                this.$http({
                    method:'post',
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },  
                    params: {
                        id : this.product.id
                    },
                    data: this.product
                }).then(()=>{                    
                    this.adding_product = false                                                                                     
                    this.getProducts()                    
                    document.getElementById('closeEditProductModal').click()  
                    this.$emit('success',"Product edited succesfully")              
                }).catch((err)=>{
                    this.adding_product = false
                    alert(err)                    
                })
            }
        },
        //add product images
        addProductImages: function(){
            this.adding_product = true
            var requests = []                                        
            // loop through all images selected
            this.product_images.forEach((file) =>{                
                var form_data = file                
                requests.push( 
                    this.axios({
                        method: 'post',
                        url : this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product-image/`, 
                        data :form_data,
                        headers: {     
                            'Content-Type': `multipart/form-data; boundary=${form_data._boundary}`,                   
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        }
                    })
                )
            }) 
            //make all requests.             
            this.axios.all(requests)
            .then(
                this.axios.spread((...responses)=>{
                    for (var response of responses){						
						var response_data = response.data
                        this.image_urls.push( response_data.base + "/" + response_data.square)                        
                    }
                    this.editProduct()
                    this.product_images = []      
                    this.adding_product = false
                })
            ).catch(()=>{
                this.adding_product = false
            })
        },
        //remove image from list of selected image
        unselectImage (image_id,url){                 
            var card = document.getElementById(`current_image_${image_id}_card`)             
    
            if (card.classList.contains("border-0")){
                card.classList.remove("border-0")
                card.classList.add("shadow")
                this.image_urls.push(url)
            }else{
                card.classList.add("border-0")
                card.classList.remove("shadow")
                var index = this.image_urls.indexOf(url)                
                if (index > -1) {
                    this.image_urls = this.image_urls.filter((item) =>{ item !== url })
                }                           
            }           
          
        },
        //delete product.
        deleteProduct: function(product){
            var confirmed = confirm(`Do you want to delete product ${product.name} from system ?`);
            if (confirmed) {
                this.$http({
                    method:'delete',
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product/${product.id}/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },            
                }).then(()=>{
                    this.$emit('success',`product deleted`)
                    this.getProducts()
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            }
        },
        deleteMultipleProducts: function(){
            this.deleting_products=true
            var requests = []
            //gather all requests
            for (var id of this.product_ids){
                requests.push(
                    this.$http({
                        method:'delete',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/product/${id}/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },
                        onUploadProgress: (progressEvent) => {
                            console.log(progressEvent)
                        }
                    })  
                )
            }  
            //make all requests
            this.axios.all(requests
            ).then(
                this.axios.spread((...responses)=>{         
                    document.getElementById('closeDeleteProductsModal').click()
                    this.$emit('success',`${responses.length} products deleted`)
                    this.getProducts()
                    this.deleting_products = false
                    this.product_ids = []
                })
            ).catch((error)=>{            
                this.$emit('alert',error)
                this.deleting_products = false                
            })

        }
    }
}
</script>